import * as _ from "lodash";
import moment from "moment";

import * as Models from "../Models";
import { AttributeGroup } from "../Models/index";

export const changeRequestsToAttributeGroup: Function = (
    changeRequests: Models.ChangeRequest[],
    nameOfTheGroup: string
): AttributeGroup => {
    const attributeGroup: AttributeGroup = {
        headers: [
            "Status",
            "Type",
            "Location",
            "Requested By",
            "Date",
            "Additional info",
            "Notes",
        ],
        name: nameOfTheGroup,
        rows: [],
    };

    _.forEach(changeRequests, (cr: Models.ChangeRequest, i: number) => {
        const row: Models.AttributeRow = {
            items: [],
        };

        row.items.push({
            description: cr.status,
            url: null,
        });

        row.items.push({
            description: cr.type,
            url: null,
        });

        if (cr.siteId) {
            row.items.push({
                description: null,
                url: {
                    id: cr.siteId,
                    type: "sites",
                    description: `${cr.siteDescription} (${cr.siteName})`,
                    url: `/api/sites/${cr.siteId}/details`,
                    additionalInfo: "",
                },
            });
        } else if (cr.assetId) {
            row.items.push({
                description: null,
                url: {
                    id: cr.assetId,
                    type: "sites",
                    description: cr.assetName,
                    url: `/api/sites/${cr.assetId}/details`,
                    additionalInfo: "",
                },
            });
        }

        row.items.push({
            description: cr.createdBy,
            url: null,
        });

        row.items.push({
            description: `${moment(
                cr.createdDate,
                "YYYY-MM-DDTHH:mm:ss.SSS"
            ).format("YYYY-MM-DD HH:mm")} (UTC)`,
            url: null,
        });

        row.items.push({
            description: JSON.stringify(cr.attributes),
            url: null,
        });

        row.items.push({
            description: cr.notes,
            url: null,
        });

        attributeGroup.rows.push(row);
    });

    return attributeGroup;
};
